/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AiOfferBatch model module.
 * @module model/AiOfferBatch
 * @version 1.0.0
 */
class AiOfferBatch {
    /**
     * Constructs a new <code>AiOfferBatch</code>.
     * @alias module:model/AiOfferBatch
     * @param id {Number} 
     * @param status {module:model/AiOfferBatch.StatusEnum} generating は未確定の item が残っている状態、ready は全 item が確定した状態。 sent / canceled は処理済み。
     * @param reProposal {Boolean} 
     * @param targetCount {Number} 依頼時の対象数（skipped を含む）
     */
    constructor(id, status, reProposal, targetCount) { 
        
        AiOfferBatch.initialize(this, id, status, reProposal, targetCount);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, id, status, reProposal, targetCount) { 
        obj['id'] = id;
        obj['status'] = status;
        obj['re_proposal'] = reProposal;
        obj['target_count'] = targetCount;
    }

    /**
     * Constructs a <code>AiOfferBatch</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AiOfferBatch} obj Optional instance to populate.
     * @return {module:model/AiOfferBatch} The populated <code>AiOfferBatch</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AiOfferBatch();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('re_proposal')) {
                obj['re_proposal'] = ApiClient.convertToType(data['re_proposal'], 'Boolean');
            }
            if (data.hasOwnProperty('target_count')) {
                obj['target_count'] = ApiClient.convertToType(data['target_count'], 'Number');
            }
            if (data.hasOwnProperty('pending_count')) {
                obj['pending_count'] = ApiClient.convertToType(data['pending_count'], 'Number');
            }
            if (data.hasOwnProperty('succeeded_count')) {
                obj['succeeded_count'] = ApiClient.convertToType(data['succeeded_count'], 'Number');
            }
            if (data.hasOwnProperty('failed_count')) {
                obj['failed_count'] = ApiClient.convertToType(data['failed_count'], 'Number');
            }
            if (data.hasOwnProperty('skipped_count')) {
                obj['skipped_count'] = ApiClient.convertToType(data['skipped_count'], 'Number');
            }
            if (data.hasOwnProperty('confirmed_count')) {
                obj['confirmed_count'] = ApiClient.convertToType(data['confirmed_count'], 'Number');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('generated_at')) {
                obj['generated_at'] = ApiClient.convertToType(data['generated_at'], 'Date');
            }
            if (data.hasOwnProperty('sent_at')) {
                obj['sent_at'] = ApiClient.convertToType(data['sent_at'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AiOfferBatch</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AiOfferBatch</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AiOfferBatch.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['status'] && !(typeof data['status'] === 'string' || data['status'] instanceof String)) {
            throw new Error("Expected the field `status` to be a primitive type in the JSON string but got " + data['status']);
        }

        return true;
    }


}

AiOfferBatch.RequiredProperties = ["id", "status", "re_proposal", "target_count"];

/**
 * @member {Number} id
 */
AiOfferBatch.prototype['id'] = undefined;

/**
 * generating は未確定の item が残っている状態、ready は全 item が確定した状態。 sent / canceled は処理済み。
 * @member {module:model/AiOfferBatch.StatusEnum} status
 */
AiOfferBatch.prototype['status'] = undefined;

/**
 * @member {Boolean} re_proposal
 */
AiOfferBatch.prototype['re_proposal'] = undefined;

/**
 * 依頼時の対象数（skipped を含む）
 * @member {Number} target_count
 */
AiOfferBatch.prototype['target_count'] = undefined;

/**
 * @member {Number} pending_count
 */
AiOfferBatch.prototype['pending_count'] = undefined;

/**
 * @member {Number} succeeded_count
 */
AiOfferBatch.prototype['succeeded_count'] = undefined;

/**
 * @member {Number} failed_count
 */
AiOfferBatch.prototype['failed_count'] = undefined;

/**
 * @member {Number} skipped_count
 */
AiOfferBatch.prototype['skipped_count'] = undefined;

/**
 * 確認済みかつ生成成功の item 数（＝送信対象数）
 * @member {Number} confirmed_count
 */
AiOfferBatch.prototype['confirmed_count'] = undefined;

/**
 * @member {Date} created_at
 */
AiOfferBatch.prototype['created_at'] = undefined;

/**
 * @member {Date} generated_at
 */
AiOfferBatch.prototype['generated_at'] = undefined;

/**
 * @member {Date} sent_at
 */
AiOfferBatch.prototype['sent_at'] = undefined;





/**
 * Allowed values for the <code>status</code> property.
 * @enum {String}
 * @readonly
 */
AiOfferBatch['StatusEnum'] = {

    /**
     * value: "generating"
     * @const
     */
    "generating": "generating",

    /**
     * value: "ready"
     * @const
     */
    "ready": "ready",

    /**
     * value: "sent"
     * @const
     */
    "sent": "sent",

    /**
     * value: "canceled"
     * @const
     */
    "canceled": "canceled"
};



export default AiOfferBatch;

